module.exports = __webpack_public_path__ + "static/cf-reg-61caf02e4c51a739d5adfaff20148817.woff";